__turbopack_context__.v({
  "className": "qOXMEG_className",
  "variable": "qOXMEG_variable",
});
